/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImportEinsaetzeRequest
 */
export interface ImportEinsaetzeRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ImportEinsaetzeRequest
     */
    ids: Array<number>;
    /**
     * Erzwingt auch dann eine Neuberechnung, wenn sich keine Einsätze geändert haben.
     * @type {boolean}
     * @memberof ImportEinsaetzeRequest
     */
    forceCalculation?: boolean;
}

/**
 * Check if a given object implements the ImportEinsaetzeRequest interface.
 */
export function instanceOfImportEinsaetzeRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "ids" in value;

    return isInstance;
}

export function ImportEinsaetzeRequestFromJSON(json: any): ImportEinsaetzeRequest {
    return ImportEinsaetzeRequestFromJSONTyped(json, false);
}

export function ImportEinsaetzeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportEinsaetzeRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ids': json['ids'],
        'forceCalculation': !exists(json, 'forceCalculation') ? undefined : json['forceCalculation'],
    };
}

export function ImportEinsaetzeRequestToJSON(value?: ImportEinsaetzeRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ids': value.ids,
        'forceCalculation': value.forceCalculation,
    };
}

